<template>
    <div>
        <div ref="distributionProjectionChart" style="height: 350px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import am4lang_id_ID from "@amcharts/amcharts4/lang/id_ID";

    export default {
        data () {
            return {
                chart: null,
                dateAxis: null,
                range2: null,
                dummyData: [
                    { date: new Date(2024, 0, 1), pengeluaran: 680, pemesanan: 480 },
                    { date: new Date(2024, 1, 1), pengeluaran: 380, pemesanan: 390 },
                    { date: new Date(2024, 2, 1), pengeluaran: 460, pemesanan: 470 },
                    { date: new Date(2024, 3, 1), pengeluaran: 660, pemesanan: 680 },
                    { date: new Date(2024, 4, 1), pengeluaran: 520, pemesanan: 500 },
                    { date: new Date(2024, 5, 1), pengeluaran: 420, pemesanan: 440 },
                ]
            }
        },
        props: ['data', 'filter'],
        mounted () {
            this.createChart();
        },
        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        },
        watch : {
            'data' : {
                deep: true,
                handler () {
                    if (this.chart) {
                        this.chart.data = (this.data && this.data.length > 0) ? this.data : this.dummyData;
                    }
                },
            }
        },
        methods : {
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.distributionProjectionChart, am4charts.XYChart);

                this.chart.language.locale = am4lang_id_ID;
                this.chart.dateFormatter.dateFormat = "MMM";
                this.chart.numberFormatter.numberFormat = "#,###";

                // Create axes
                this.dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
                this.dateAxis.renderer.grid.template.location = 0;
                this.dateAxis.renderer.grid.template.strokeOpacity = 0;
                this.dateAxis.renderer.minGridDistance = 40;
                this.dateAxis.baseInterval = { timeUnit: "month", count: 1 };
                this.dateAxis.dateFormats.setKey("month", "MMM");
                this.dateAxis.periodChangeDateFormats.setKey("month", "MMM");
                this.dateAxis.renderer.labels.template.fontSize = 12;
                this.dateAxis.renderer.labels.template.fill = am4core.color("#6B7280");

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.labels.template.verticalCenter = "middle";
                valueAxis.renderer.labels.template.dx = -5;
                valueAxis.renderer.labels.template.fontSize = 12;
                valueAxis.renderer.labels.template.fill = am4core.color("#6B7280");
                valueAxis.renderer.grid.template.stroke = am4core.color("#F3F4F6");
                valueAxis.renderer.grid.template.strokeOpacity = 1;
                valueAxis.min = 0;
                valueAxis.max = 1750;
                valueAxis.strictMinMax = false;

                // Create series
                const createSeries = (field, name, color) => {
                    let series = this.chart.series.push(new am4charts.LineSeries());
                    series.dataFields.valueY = field;
                    series.dataFields.dateX = "date";
                    series.name = name;
                    series.tooltipHTML = `
                        <div style="padding: 6px 8px; min-width: 140px;">
                            <div style="color: #9CA3AF; font-size: 12px; margin-bottom: 6px;">
                                {dateX.formatDate('MMMM')}
                            </div>
                            <div style="display: flex; justify-content: space-between; align-items: center; font-size: 13px; color: #111827;">
                                <span style="display: flex; align-items: center;">
                                    <span style="display: inline-block; width: 8px; height: 8px; border-radius: 2px; background: ${color.hex}; margin-right: 6px;"></span>
                                    ${name}
                                </span>
                                <span style="font-weight: 600; margin-left: 16px;">{valueY.formatNumber('#,###')}</span>
                            </div>
                        </div>
                    `;
                    series.strokeWidth = 2;
                    series.smoothing = "monotoneX";
                    series.stroke = color;

                    let bullet = series.bullets.push(new am4charts.CircleBullet());
                    bullet.circle.radius = 3;
                    bullet.circle.fill = color;
                    bullet.circle.strokeWidth = 2;
                    bullet.circle.stroke = am4core.color("#FFFFFF");

                    series.createLegendMarker = function(marker) {
                        marker.disposeChildren();
                        let rect = marker.createChild(am4core.RoundedRectangle);
                        rect.width = 10;
                        rect.height = 10;
                        rect.cornerRadius(2, 2, 2, 2);
                        rect.fill = color;
                        rect.strokeWidth = 0;
                    };

                    return series;
                };

                const customizeTooltip = (series) => {
                    series.tooltip.getFillFromObject = false;
                    series.tooltip.background.fill = am4core.color("#FFFFFF");
                    series.tooltip.background.stroke = am4core.color("#E5E7EB");
                    series.tooltip.background.strokeWidth = 1;
                    series.tooltip.background.cornerRadius = 6;
                    series.tooltip.background.filters.clear();
                    series.tooltip.autoTextColor = false;
                    series.tooltip.label.fill = am4core.color("#111827");
                    series.tooltip.label.fontSize = 12;
                    series.tooltip.label.textAlign = "start";
                };

                this.chart.legend = new am4charts.Legend();
                this.chart.legend.position = "bottom";
                this.chart.legend.contentAlign = "center";
                this.chart.legend.markers.template.width = 10;
                this.chart.legend.markers.template.height = 10;
                this.chart.legend.labels.template.fontSize = 12;
                this.chart.legend.labels.template.fill = am4core.color("#374151");
                this.chart.cursor = new am4charts.XYCursor();

                createSeries("pemesanan", "Pengiriman dari MD", am4core.color("#22C55E"));
                customizeTooltip(this.chart.series.values[0]);

                createSeries("pengeluaran", "Pemakaian Dealer", am4core.color("#A855F7"));
                customizeTooltip(this.chart.series.values[1]);

                this.chart.data = (this.data && this.data.length > 0) ? this.data : this.dummyData;
            }
        }
    }
</script>